import { render, staticRenderFns } from "./netResource.vue?vue&type=template&id=cbd7cba6&scoped=true&"
import script from "./netResource.vue?vue&type=script&lang=js&"
export * from "./netResource.vue?vue&type=script&lang=js&"
import style0 from "./netResource.vue?vue&type=style&index=0&id=cbd7cba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd7cba6",
  null
  
)

export default component.exports